import React from 'react';

export const Photo_Title = [
  {
    textSize: '4rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h2',
    renderContent: () => <span>PHOTOGRAPHERS</span>,
  },
];

export const Photo_Erick = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>ERICK</em>
        <br />
        <strong>GUEVARA</strong>
      </span>
    ),
  },
];

export const Photo_Gregory = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>GREGORY</em>
        <br />
        <strong>ALLEN</strong>
      </span>
    ),
  },
];

export const Photo_Jose = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>JOSÉ R</em>
        <br />
        <strong>CAGIGAS</strong>
      </span>
    ),
  },
];

export const Photo_Yvone = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>YVONE</em>
        <br />
        <strong>BELANGER</strong>
      </span>
    ),
  },
];

export const Photo_Mario = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>MARIO</em>
        <br />
        <strong>MACÍN</strong>
      </span>
    ),
  },
];

export const Photo_Alejandro = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>ALEJANDRO</em>
        <br />
        <strong>YAÑES</strong>
      </span>
    ),
  },
];

export const Photo_Carlos = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    lineHeight: '100%',
    textType: 'h3',
    textMobile: '2rem',
    renderContent: () => (
      <span>
        <em>CARLOS</em>
        <br />
        <strong>SOMONTE</strong>
      </span>
    ),
  },
];

export const Text_Jose = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        José Ramón Cagigas is an automotive photographer focused on capturing
        the design, power, and identity of each vehicle through a precise,
        technical lens. With an approach that combines lighting control,
        composition, and detail, he creates images that highlight both the
        aesthetics and the character of cars—adapting seamlessly to editorial,
        commercial, and brand productions.
      </span>
    ),
  },
];

export const TextPhoto1_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>VEHICLE</span>,
  },
];

export const TextPhoto2_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRITY</span>,
  },
];

export const TextPhoto3_Jose = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOOD</span>,
  },
];

export const Text_Yvone = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Yvonne Bélanger is a food and still life photographer based in Mexico
        City, with over 20 years of professional experience. Throughout her
        career, she has worked with magazines, advertising agencies, and direct
        clients, including brands such as KFC, Bimbo, Danone, Domino’s Pizza, PF
        Chang’s, Chili’s, IHOP, Hellmann’s, Jumex, and La Moderna, among others.
        With her extensive experience, she adapts seamlessly to both on-location
        productions and studio shoots. She works alongside a solid team of prop
        stylists, food stylists, and retouchers, ensuring precise and consistent
        results on every project.
      </span>
    ),
  },
];

export const TextPhoto1_Yvone = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOOD</span>,
  },
];

export const TextPhoto2_Yvone = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>SPLASH</span>,
  },
];

export const Text_Mario = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Mario Macín is a professional photographer with a solid background in
        both artistic and commercial photography. His work spans portraiture,
        fashion, advertising, and editorial photography. With training in
        photography, architecture, and dance, he has developed a distinctive
        style that blends visual aesthetics with artistic sensitivity.
        Throughout his career, he has collaborated with recognized brands and
        figures, bringing a contemporary perspective to each project. His work
        is defined by a precise use of light, shadow, and color, and has been
        exhibited in multiple showcases—solidifying his place within
        contemporary photography in Mexico.
      </span>
    ),
  },
];

export const TextPhoto1_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const TextPhoto2_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>EDITORIAL</span>,
  },
];

export const TextPhoto3_Mario = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>PORTRAIT</span>,
  },
];

export const Text_Gregory = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Gregory Allen is a fashion, beauty, and advertising photographer based
        between Mexico City and New York. In 2017, he was named Photographer of
        the Year by the Fashion Digital Awards Mexico. For over 15 years, he has
        worked internationally with brands such as L’Oréal, Maybelline New York,
        Coppel, El Palacio de Hierro, Gerber, and Nestlé, as well as
        publications including Glamour, InStyle, Travel + Leisure, and Harper’s
        Bazaar.
      </span>
    ),
  },
];

export const TextPhoto1_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>KIDS</span>,
  },
];

export const TextPhoto2_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>EDITORIAL</span>,
  },
];

export const TextPhoto3_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRITY</span>,
  },
];

export const TextPhoto4_Gregory = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Erick = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Erick Guevara is a photographer and visual artist specializing in
        portraits of models, celebrities, and personalities, with a strong focus
        on film and series. His work stands out for an intense, cinematic
        aesthetic where the face, expression, and character become the absolute
        center of the image. He has developed official catalogs and key art
        posters for audiovisual productions, combining technical precision with
        powerful visual storytelling. His photography doesn’t aim to decorate—it
        aims to confront, reveal, and endure.
      </span>
    ),
  },
];

export const TextPhoto1_Erick = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>POSTERS</span>,
  },
];

export const TextPhoto2_Erick = [
  {
    textSize: '43remrem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Carlos = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Carlos Somonte is a photographer with a background in Marine Biology
        from the Universidad Autónoma Metropolitana, as well as postgraduate
        studies in Photography in London. His work has been exhibited both
        individually and collectively in museums and galleries across Mexico,
        England, Germany, Spain, Poland, Australia, China, the United States,
        Canada, Cuba, and India. In 2005, he presented a retrospective at Centro
        de la Imagen during FotoSeptiembre, showcasing nearly 900 images in
        formats ranging from Polaroid to large-format 8×10. His work is part of
        international collections and publications.
      </span>
    ),
  },
];

export const TextPhoto1_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FILMS</span>,
  },
];

export const TextPhoto2_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>POSTERS</span>,
  },
];

export const TextPhoto3_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CELEBRITY</span>,
  },
];

export const TextPhoto4_Carlos = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FASHION</span>,
  },
];

export const Text_Alejandro = [
  {
    textSize: '0.938rem',
    marginBottom: '0px',
    lineHeight: '1.3',
    fontWeight: '500',
    textType: 'p',
    textMobile: '0.688rem',
    renderContent: () => (
      <span>
        Alejandro Yañes is a photographer with a versatile approach spanning
        portraiture, landscape, architecture, and food photography. His work is
        defined by a sensitive, well-crafted perspective where composition,
        light, and atmosphere take center stage. He moves between color and
        black-and-white to document people, spaces, and food through an honest,
        aesthetic lens—prioritizing the character of the moment over staged
        perfection. His photography bridges the everyday with the visually
        unforgettable.
      </span>
    ),
  },
];

export const TextPhoto1_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>LANDSCAPE</span>,
  },
];

export const TextPhoto2_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>CULTURAL</span>,
  },
];

export const TextPhoto3_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>FOOD</span>,
  },
];

export const TextPhoto4_Alejandro = [
  {
    textSize: '3rem',
    marginBottom: '0px',
    lineHeight: '100%',
    fontWeight: '500',
    textType: 'h3',
    textMobile: '0.875rem',
    renderContent: () => <span>ARCHITECTURE</span>,
  },
];
